import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_96: FaireProductEntity = {
  token: "catalog_prod_prod-96",
  type: "product",
  name: "Textile Item",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 74.26,
  msrpDollars: 185.65,
  sku: "CA0096",
  caseSize: 4,
  material: "Linen",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 28,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_coffee-tea"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
